/* =============================================================
   SUPABASE CLIENT
   =============================================================
   One client for the whole panel, on the anon key.

   That is not a compromise: every write this tool makes is
   authorised by RLS against `public.is_platform_admin()`, which
   reads `platform_admins` on the server from the JWT's subject.
   A service-role key would make the checks unnecessary and the
   panel wildly unsafe — it bypasses RLS and ships in plain text
   to every browser that loads the page.
   ============================================================= */

import { createClient } from '@supabase/supabase-js'
import { env, isSupabaseConfigured } from '@/config/env'

if (!isSupabaseConfigured) {
  // Loud, immediate, and before any screen renders. See config/env.ts.
  throw new Error(
    'Supabase is not configured. Set VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY ' +
      '(copy admin/.env.example to admin/.env.local).',
  )
}

export const supabase = createClient(env.supabaseUrl, env.supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    // No magic links or OAuth redirects land here, so there is no callback
    // fragment to parse — and leaving it on would make the client try.
    detectSessionInUrl: false,
  },
})
